import { render, staticRenderFns } from "./LogsReportBuilderHistoryPageComponent.vue?vue&type=template&id=247d06bc"
import script from "./LogsReportBuilderHistoryPageComponent.vue?vue&type=script&lang=js"
export * from "./LogsReportBuilderHistoryPageComponent.vue?vue&type=script&lang=js"
import style0 from "./LogsReportBuilderHistoryPageComponent.vue?vue&type=style&index=0&id=247d06bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports